import { render, staticRenderFns } from "./MaterialInventoryDetails.vue?vue&type=template&id=1a8227aa&scoped=true"
import script from "./MaterialInventoryDetails.vue?vue&type=script&lang=js"
export * from "./MaterialInventoryDetails.vue?vue&type=script&lang=js"
import style0 from "./MaterialInventoryDetails.vue?vue&type=style&index=0&id=1a8227aa&prod&scoped=true&lang=scss"
import style1 from "./MaterialInventoryDetails.vue?vue&type=style&index=1&id=1a8227aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8227aa",
  null
  
)

export default component.exports